/**
 * Plaza — wspólne stałe sceny placu handlowego (Etap 5.B).
 *
 * Single source dla wymiarów planszy po stronie KLIENTA (PlazaScene + net layer).
 *
 * ⚠️ PARITY: serwer realtime trzyma WŁASNĄ kopię tych wartości w
 * `server/realtime/src/index.ts` (PLAZA_W/PLAZA_H) — server clampuje pozycje
 * graczy do tych granic (anti-cheat). Wartości MUSZĄ być identyczne, inaczej
 * gracz „wyjedzie" poza planszę u siebie, a serwer go cofnie (rubber-banding).
 * Cross-language (TS frontend ↔ TS backend, osobne buildy) nie da się trywialnie
 * współdzielić jednego modułu — przy zmianie wymiarów ZMIEŃ OBA miejsca.
 * (Codex 5.B.3 pytanie 4: na 5.B.4 frontend dostaje wreszcie 1 źródło prawdy.)
 */

// 5.B.6f FIXES (Codex MED 1): plaza powiększona 1600→2400, 1200→1600 (clean 3:2).
// Powód: szeroki paddock (PADDOCK_W=360) wymaga ≥400 px spacing slotów. Stary
// obwód 4000 / 16 slotów = 250 px → sąsiednie zagrody nachodziły. Po bumpie
// obwód = 6400 / 16 = 400 px → paddock 360 mieści się z 40 px marginesem.

/** Szerokość planszy plazy w px. Musi == server PLAZA_W. */
export const PLAZA_W = 2400;

/** Wysokość planszy plazy w px. Musi == server PLAZA_H. */
export const PLAZA_H = 1600;
